import { authenticateUser } from '@eneco/customer-insights';
import { assign } from 'xstate';


import { FlowContextSme } from '../context';

export const msciAuthenticateByEmail = assign(({ context, event }) => {
  if ('values' in event && event?.values?.emailAddress) {
    authenticateUser(event.values.emailAddress);
  }
  return context;
});

const getAddress = (values: FlowContextSme) => {
  const { postalCode, houseNumber, houseNumberSuffix = '' } = values || {};
  if (postalCode && houseNumber) {
    return [postalCode, houseNumber, houseNumberSuffix].join(' ').trim();
  }
};

export const msciAuthenticateByAddress = assign((context: FlowContextSme) => {
  const address = getAddress(context);

  if (address) {
    authenticateUser(`zip: ${address}`);
  }

  return context;
});

export const msciAuthenticateByKVK = assign(({ context }) => {
  const { chamberOfCommerceNumber } = context;

  if (chamberOfCommerceNumber) {
    authenticateUser(`kvk: ${chamberOfCommerceNumber}`);
  }
  return context;
});
